export default __webpack_public_path__ + "static/google-app-store-badge-6fb903142b6cd19b10566ad63b121ac4.png";